import { useState, useEffect } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
// child
import Input from "../../ChildComponents/Input";
import BrandButton from "../../ChildComponents/BrandButton";

// validationSchema
import { Rolechema } from "../../Components/validation/roleValidation";

// api
import { useCreateRole, useUpdateRole } from "../../store/api/roleApi";

function RoleForm({ data, editId, onSuccessCreated }) {
  const updateRole = useUpdateRole(editId?._id);
  // init
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
  } = useForm({
    resolver: yupResolver(Rolechema),
  });

  useEffect(() => {
    if (editId) {
      reset({
        name: editId.name,
        accessPoint: editId.accessPoint || [],
      });
      setEdited(true);
    }
  }, [editId, reset]);

  const createRole = useCreateRole();
  const navData = data.data;

  const [loading, setLoading] = useState(false);
  const [edited, setEdited] = useState(editId ? true : false);

  const mutation = useMutation({
    mutationFn: (data) => {
      return editId ? updateRole(data) : createRole(data);
    },
    onSuccess: (data) => {
      setLoading(false);
      toast.success("Creatred Successfuly");
      reset();
      onSuccessCreated(1);
    },
    onError: (error) => {
      toast.error(error.message);
      setLoading(false);
    },
  });

  const onSubmit = (formData) => {
    setLoading(true);

    try {
      mutation.mutate({
        name: formData.name,
        accessPoint: formData.accessPoint,
      });
    } catch (error) {
      setLoading(false);
      console.error("Caught error in handleSubmit:", error.message);
      toast.error(error.message);
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)} action="">
        <div className="row">
          <div className="col-sm-4">
            <Input
              icon="title"
              {...register("name")}
              error={errors.name?.message}
              type="text"
              placeholder={`admin, editor, reporters`}
              label="Role Name"
            />
          </div>
          <div className="col-sm-8 mt-4">
            <BrandButton
              type="submit"
              title={`${!loading ? "Save" : "Loading...."}`}
            />
          </div>
        </div>

        <div className="row">
          {navData.map((item, index) => (
            <div className="col-sm-3 mb-3" key={index}>
              <div className="shadow-sm bg-white p-3 rounded">
                <ul className="list-unstyled">
                  <li>
                    <input
                      type="checkbox"
                      className="me-2"
                      value={item.url}
                      {...register("accessPoint")}
                      error={errors.accessPoint?.message}
                    />
                    <strong>{item.label}</strong>

                    {item.subNav?.length > 0 && (
                      <ul className="list-unstyled ps-3 mt-2">
                        {item.subNav.map((subItem, subIndex) => {
                          const baseKey = subItem.url;
                          return (
                            <li key={subIndex} className="mb-1">
                              <input
                                type="checkbox"
                                className="me-2"
                                value={baseKey}
                                {...register("accessPoint")}
                                error={errors.accessPoint?.message}
                              />
                              {subItem.label}
                              <ul className="list-unstyled ps-4 text-muted small mt-1">
                                {["edit", "read", "delete"].map((action) => {
                                  const actionKey = `${baseKey}_${action}`;
                                  return (
                                    <li key={actionKey}>
                                      <input
                                        type="checkbox"
                                        className="me-1"
                                        value={actionKey}
                                        {...register("accessPoint")}
                                        error={errors.accessPoint?.message}
                                      />{" "}
                                      {action.charAt(0).toUpperCase() +
                                        action.slice(1)}
                                    </li>
                                  );
                                })}
                              </ul>
                            </li>
                          );
                        })}
                      </ul>
                    )}
                  </li>
                </ul>
              </div>
            </div>
          ))}
        </div>
        <BrandButton
          type="submit"
          // title={`${!loading ? "Login" : "Loading...."}`}
          title={`Save Change`}
          className="my-5"
        />
      </form>
    </div>
  );
}

export default RoleForm;
